import Vue from 'vue'
import {sentryService, userService, resourceService} from '../';
import _ from 'lodash'

function isFeaturesSupported() {
  return window.Promise && window.fetch;
}

function loadPolyfill(url, callback) {
  const scriptElem = document.createElement('script');
  scriptElem.src = url;
  scriptElem.onload = () => callback();
  scriptElem.onerror = () => callback(new Error('Failed to load script ' + url));
  document.head.appendChild(scriptElem);
}

function loadPolyfills(callback) {
  let polyfillQueue = [
    'https://cdn.jsdelivr.net/npm/promise-polyfill@8/dist/polyfill.min.js',
    'https://cdn.jsdelivr.net/npm/whatwg-fetch@3.0.0/dist/fetch.umd.min.js'
  ];

  polyfillQueue.forEach(url => loadPolyfill(url, () => {
    polyfillQueue = polyfillQueue.filter(itemUrl => itemUrl !== url);
    if (!polyfillQueue.length) callback();
  }));
}

const defaultOptions = {
  config: {
    appId: 0,
    sentryDsnCode: null,
    loadResources: true,
    loadUserInfo: true,
    loadPolyfillsForUnsupportedFeatures: true
  },
  user: {
    id: null,
    type: null,
    name: '',
    username: '',
    email: ''
  }
};

function init(App, options) {
  options = _.merge({}, defaultOptions, options);

  Vue.config.productionTip = false;
  Vue.prototype.$appId = options.config.appId;

  if (options.config.sentryDsnCode != null) {
    sentryService.init(Vue, options.sentryDsnCode);
  }

  if (options.config.loadPolyfillsForUnsupportedFeatures) {
    if (isFeaturesSupported()) runApp(App, options);
    else loadPolyfills(() => runApp(App, options));
  }
}

function runApp(app, options) {
  Promise.all(resolveAsyncTasks(options))
      .then(function (res) {})
      .finally(() => {
        /* eslint-disable no-new */
        new Vue({render: h => h(app)}).$mount('#app');
      });
}

function resolveAsyncTasks(options) {
  let asyncTasks = {
    loadResources: {
      action: () => resourceService.getResources(options.config.appId),
      onSuccess: (res) => Vue.prototype.$resources = Vue.observable(res)
    },
    loadUserInfo: {
      action: () => userService.getUserInfo(),
      onSuccess: (res) => {
        Vue.prototype.$user = {...options.user, ...res};
        if (options.config.sentryDsnCode) sentryService.addUserInfo(Vue.prototype.$user);
        return Vue.prototype.$user;
      }
    }
  };

  return Object.keys(asyncTasks)
      .filter(key => options.config[key])
      .map(key => {
        const task = asyncTasks[key];
        return task.action().then(
            task.onSuccess || function(res) { return res; },
            task.onError || function(err) { throw err;}
        )
      });
}

export default {init}
